import { AppRoutes } from "@/routes/config";
import { TTabbedSessionState, useListSessionStorage } from "@/hooks/useListSessionStorage";

const CONTACT_LIST_SESSION_KEY = "contact_list_state";

export type TContactListSessionState = TTabbedSessionState;

export const useContactListSessionStorage = () => {
  return useListSessionStorage<TContactListSessionState>({
    sessionKey: CONTACT_LIST_SESSION_KEY,
    defaultBackUrl: AppRoutes.unresolvedContact,
    getBackUrlFromState: (state) => {
      const { activeTabUrl, searchParams } = state;
      if (searchParams) {
        return `${activeTabUrl}?${searchParams}`;
      }
      return activeTabUrl;
    },
  });
};
